//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import AssistantChat from '~/components/AssistantChat.vue'

export default {
  name: 'AssistantBubble',
  components: { AssistantChat },

  data () {
    return {
      open: false,
      // Once true the chat stays mounted, so reopening resumes the same
      // conversation rather than starting a new chat session.
      everOpened: false
    }
  },

  computed: {
    ...mapGetters({
      loggedInUser: 'user/loggedInUser',
      canUseAssistant: 'user/canUseAssistant'
    }),

    // Kept here rather than in each layout, so adding the bubble to another
    // layout stays a one-line change. Hidden on /assistant, where the page
    // provides the chat — two on one page would be two sessions.
    // Matched on route NAME, not path: the nav links to `/assistant/` with a
    // trailing slash, which a path comparison would miss.
    visible () {
      return Boolean(this.loggedInUser) && this.canUseAssistant && Boolean(this.$config.chippAppId) && this.$route.name !== 'assistant'
    }
  },

  methods: {
    toggle () {
      this.open = !this.open
      if (this.open) { this.everOpened = true }
    }
  }
}
